import { Reveal } from "./Reveal";

const ITEMS = [
  "DIPERCAYA 150+ TRAVEL UMROH ASIA TENGGARA",
  "INDONESIA",
  "MALAYSIA",
  "SINGAPURA",
  "BRUNEI DARUSSALAM",
  "THAILAND SELATAN",
];

const STATS = [
  { value: "50.000+", label: "Permit Rawdah Terbit" },
  { value: "99,8%", label: "Tingkat Keberhasilan Booking" },
  { value: "100%", label: "Keamanan Data Visa Jamaah" },
  { value: "±15 Mnt", label: "Rata-rata Respon Admin" },
];

export const TrustMarquee = () => (
  <section className="relative border-y border-white/8 bg-[#0A0F1D]" data-testid="trust-section">
    <div className="py-6 overflow-hidden" data-testid="trust-marquee">
      <div className="flex w-max animate-marquee">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex items-center shrink-0" aria-hidden={copy === 1}>
            {ITEMS.map((item) => (
              <span key={`${copy}-${item}`} className="flex items-center">
                <span className="font-display text-lg sm:text-xl font-bold tracking-wide text-slate-500 px-8 whitespace-nowrap">
                  {item}
                </span>
                <span className="w-1.5 h-1.5 rotate-45 bg-sky-500/60 shrink-0" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>

    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-14 pt-4">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
        {STATS.map((s, i) => (
          <Reveal key={s.label} delay={i * 0.08}>
            <div className="text-center lg:text-left" data-testid={`stat-${i}`}>
              <p className="font-mono2 font-semibold text-3xl sm:text-4xl text-gradient-silver">{s.value}</p>
              <p className="text-sm text-slate-400 mt-2">{s.label}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
